@if (fieldDef.meta?.value_hidden) {
  <mat-form-field class="flex-auto w-full gt-xs:pr-3 contact-wrapper">
    <mat-label>{{ fieldDef.label }}</mat-label>
    <input #inputControl matInput [(ngModel)]="displayValue" disabled class="blurred" />
  </mat-form-field>
} @else {
  <ng-container
    *ngIf="
      customObjType === 'Company' ||
      customObjType === 'Contact' ||
      customObjType === 'Property' ||
      customObjType === 'Project' ||
      customObjType === 'User' ||
      isCustomObjectLookup
    "
  >
    <div class="flex-auto w-full gt-xs:pr-3 min-w-0">
      <label
        class="block text-ts-input-label-size text-ts-input-label font-ts-input-label-weight leading-ts-input-label"
      >
        <span class="text-ellipsis overflow-hidden pointer-events-auto" [matTooltip]="fieldDef.label" tooltipIfEllipsis>
          {{ fieldDef.label }}
        </span>
      </label>
      <ng-template #selectedContactTemplate let-info>
        <a class="selected-value-link" (click)="goToRecord(null, $event); $event.stopPropagation()">
          {{ info.label }}
        </a>
      </ng-template>

      <div
        class="ts-select-wrapper"
        [ngClass]="{ disabled: isDisabled }"
        TsFieldStyling
        [fieldBackgroundColor]="fieldStyling().color"
        [fieldBold]="fieldStyling().is_bold"
        [targetStylingClass]="tsSelectTargetStylingClass"
        style="max-width: 100%"
      >
        <ts-select
          [ngModel]="tsSelectValue"
          [tooltip]="tooltipValue"
          [listItemTooltip]="true"
          (ngModelChange)="onTsSelectChange($event)"
          [name]="fieldDef.name"
          [items]="searchOptions"
          [itemKey]="itemKey"
          [itemLabel]="itemLabel"
          [multi]="isMultipleField"
          [multiDisplayMode]="'comma'"
          [disabled]="isDisabled"
          [uiOptions]="{
            placeholder: 'Type to search...',
            searchPlaceholder: 'Search...',
          }"
          (searchChange)="onSearchChange($event)"
          [searchLoading]="isLoadingOptions"
          [fieldSearchItems]="fieldSearchItemsForSelect"
          (fieldSearchChange)="onFieldSearchSelect($event)"
          (panelToggled)="onSelectPanelToggled($event)"
          [selectedItemTemplate]="isMultipleField || customObjType === 'User' ? null : selectedContactTemplate"
        >
        </ts-select>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="customObjType === 'FileResource'">
    <mat-form-field
      TsFieldStyling
      [fieldBackgroundColor]="fieldStyling().color"
      [fieldBold]="fieldStyling().is_bold"
      [targetStylingClass]="commonTargetStylingClass"
      class="flex-auto w-full gt-xs:pr-3 contact-wrapper file-drop-zone"
      (dragover)="onDragOver($event)"
      (dragenter)="onDragEnter($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onFileDrop($event)"
    >
      <mat-label>{{ fieldDef.label }}</mat-label>
      <input style="display: none" matInput />
      @if (!canViewFiles) {
        <span class="file-resource-label">{{ permissionDenyLabel }}</span>
      }
      <div
        [matTooltip]="showTip"
        class="flex flex-row justify-between items-center w-full"
        *ngIf="!uploadingFile && canViewFiles"
      >
        @if (!value && canUploadFiles) {
          <span class="file-resource-label"> Upload a file... </span>
        }
        <span
          class="file-resource-link"
          [appAuthorize]="NewPermission.FILES_VIEW"
          denyAction="disable"
          (click)="viewFile(fileResource)"
          *ngIf="!isMultipleField"
        >
          {{ value | readableField: model : fieldDef : [] }}
        </span>

        <ng-container
          *ngIf="isMultipleField"
          [ngTemplateOutlet]="multipleRecordList"
          [ngTemplateOutletContext]="{ value: value }"
        ></ng-container>

        <ng-container *ngIf="(!value || isMultipleField) && !isDisabled">
          <input
            style="display: none"
            type="file"
            (change)="onFileChanged($event)"
            #addFileInput
            [accept]="acceptAttribute"
            [multiple]="isMultipleField"
          />
          <ts-button
            [class.always-visible]="isMultipleField"
            class="mr-2 add-file-btn"
            type="icon"
            htmlButtonType="button"
            [appAuthorize]="[NewPermission.FILES_VIEW, NewPermission.FILES_CREATE]"
            (buttonClick)="addFileInput.click()"
            [disabled]="isDisabled"
            svgIcon="add_box"
          ></ts-button>
        </ng-container>

        <ng-container *ngIf="!isMultipleField && !!value && !isDisabled">
          <span matSuffix>
            <ts-button
              type="icon"
              htmlButtonType="button"
              buttonTooltip="More actions"
              [matMenuTriggerFor]="menu"
              icon="more_vert"
            ></ts-button>
          </span>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              *ngIf="value && !isDisabled"
              [appAuthorize]="NewPermission.FILES_VIEW"
              (click)="downloadFile(fileResource)"
            >
              <mat-icon [svgIcon]="'get_app'"></mat-icon>
              <span>Download</span>
            </button>

            <button
              mat-menu-item
              [appAuthorize]="[NewPermission.FILES_VIEW, NewPermission.FILES_CREATE, NewPermission.FILES_EDIT]"
              (click)="editFileInput.click()"
            >
              <mat-icon>edit</mat-icon>
              <input
                style="display: none"
                type="file"
                (change)="onFileChanged($event)"
                #editFileInput
                [accept]="acceptAttribute"
              />
              <span>Edit</span>
            </button>

            <button
              mat-menu-item
              [appAuthorize]="[NewPermission.FILES_VIEW, NewPermission.FILES_EDIT]"
              (click)="removeModelField($event)"
              *ngIf="value && !isDisabled"
            >
              <mat-icon>cancel</mat-icon>
              <span>Remove</span>
            </button>
          </mat-menu>
        </ng-container>
      </div>
      <mat-progress-bar *ngIf="uploadingFile" mode="indeterminate"></mat-progress-bar>
      <mat-hint class="pb-1" *ngIf="hasImageRecordFormat"
        >Supported formats: {{ imageRecordFormats.join(', ') }}</mat-hint
      >
      @if (isDraggingOver) {
        <div class="file-drop-zone__overlay">
          <mat-icon svgIcon="ts_file-import" class="icon-size-24 animate-pulse text-secondary"></mat-icon>
        </div>
      }
    </mat-form-field>
  </ng-container>

  <ng-container *ngIf="customObjType === 'Engagement'">
    <mat-form-field
      TsFieldStyling
      [fieldBackgroundColor]="fieldStyling().color"
      [fieldBold]="fieldStyling().is_bold"
      [targetStylingClass]="commonTargetStylingClass"
      class="flex-auto w-full gt-xs:pr-3 contact-wrapper"
    >
      <mat-label>{{ fieldDef.label }}</mat-label>
      <input style="display: none" #inputControl matInput [ngModel]="value" (ngModelChange)="value = $event" />
      <div [matTooltip]="showTip" class="flex flex-row items-center w-full" *ngIf="value">
        @if (value) {
          {{ value?.engagement_type }} on {{ value?.event_date | date: 'MMM dd, y' }}
        }
      </div>
    </mat-form-field>
  </ng-container>

  <ng-container *ngIf="hasNoRecordType()">
    <mat-form-field
      TsFieldStyling
      [fieldBackgroundColor]="fieldStyling().color"
      [fieldBold]="fieldStyling().is_bold"
      [targetStylingClass]="commonTargetStylingClass"
      class="flex-auto w-full gt-xs:pr-3 contact-wrapper"
    >
      <mat-label>{{ fieldDef.label }}</mat-label>
      <input style="display: none" #inputControl matInput [ngModel]="value" (ngModelChange)="value = $event" />
      <div [matTooltip]="showTip" class="flex flex-row items-center w-full" *ngIf="value">
        <task-status [task]="value" [taskStatuses]="workflowStates" (onUpdate)="updateTask(value)"></task-status>
        <a (click)="goToRecord()">
          <div class="flex flex-col">
            <span class="font-semibold leading-none">{{ value.title }}</span>
            <span class="mt-1 text-sm leading-none text-secondary">
              <span *ngIf="value.due_date">{{ value.due_date | date: 'LLL dd, y' }}</span>
              <span *ngIf="value.assigned_user_name">• {{ value.assigned_user_name }}</span>
            </span>
          </div>
        </a>
      </div>
    </mat-form-field>
  </ng-container>

  <!-- RECORD MULTIPLE INPUT -->
  <ng-template let-value="value" #multipleRecordList>
    <mat-chip-grid #chipList class="my-3">
      <mat-chip-row
        *ngFor="let item of value"
        [removable]="!isDisabled && canEditFiles"
        (removed)="!isDisabled && removeItem(item)"
        (click)="onMultipleRecordChipClick(item)"
      >
        {{ item.split('|')[1] }}
        @if (!isDisabled && canEditFiles) {
          <button type="button" matChipRemove [attr.aria-label]="'Remove ' + item.split('|')[1]">
            <mat-icon>cancel</mat-icon>
          </button>
        }
      </mat-chip-row>
      <input class="display-none" disabled [matChipInputFor]="chipList" />
    </mat-chip-grid>
  </ng-template>
}
